import { bookingManagementQueryKeys as e } from "./useManagementQueryKeys.mjs";
import { useQueries as t } from "@maat/store-hooks";
import { bookingsApi as n } from "@maat/api-booking";
//#region src/management/useBookingsByIdsQuery.ts
var r = (r) => {
	let i = t({ queries: r.map((t) => ({
		queryKey: e.detail(t),
		queryFn: () => n.getBooking(t),
		staleTime: 3e4
	})) });
	return {
		bookings: i.map((e) => e.data?.booking).filter((e) => !!e),
		isLoading: i.some((e) => e.isLoading)
	};
};
//#endregion
export { r as useBookingsByIdsQuery };
